export default {
  "content": "<title>ink drop</title><path d=\"M17.66 8L12 2.35 6.34 8A8.02 8.02 0 004 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0011.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zm-9.9 1c.01-2-1.14 1.73 0 .6L12 5.27l4.24 4.38c1.14 1.12-.25-4.15-.24-2.15l-4-2.23L7.76 9z\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};